import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchPosts } from '../../store/slices/post.slice'
import { Link } from 'react-router-dom'
import { ArticleTag } from '../HomePage/ArticleTag'
import { postListNewImages } from '../../services/images.service'
import { Loader } from '../FarmerMotion/Loader'

export function UserPosts({ userId }) {
  const dispatch = useDispatch()
  const posts = useSelector((state) => state.postModule.posts || [])
  const isLoading = useSelector((state) => state.postModule.isLoading)

  useEffect(() => {
    dispatch(fetchPosts({ userId }))
  }, [dispatch, userId])

  if (isLoading)
    return <Loader />
  if (!posts.length)
    return <div className="text-center py-8 text-white">לא נמצאו פוסטים</div>

  return (
    <div className="container mx-auto px-4">
      {posts
        .slice()
        .reverse()
        .map((post) => (
          <div
            key={post._id}
            className="p-4 mb-8 rounded shadow-sm flex flex-col"
          >
            <div className="flex flex-col md:flex-row gap-4">
              {/* תמונה ותגים */}
              <div className="flex-shrink-0">
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="w-full md:w-56 h-44 object-cover "
                />
                <div className="mt-[-10px]">
                  {post.tags && <ArticleTag tags={post.tags} />}
                </div>
              </div>

              {/* טקסט */}
              <div className="flex flex-col justify-center w-full gap-4">
                <div>
                  <h3 className="text-xl md:text-2xl text-white mb-1">
                    {post.title}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-400">
                    תאריך יצירה: {new Date(post.createdAt).toLocaleDateString()}
                  </p>
                </div>

                <div className="text-softText text-sm leading-snug">
                  {post.description}
                </div>

                <div className="text-end">
                  <Link
                    to={`/post/${post._id}`}
                    className="text-sm text-primary hover:underline"
                  >
                    מעבר לפוסט
                  </Link>
                </div>
              </div>
            </div>

            <img
              className="w-full mt-6"
              src={postListNewImages.longLineDivider}
              alt="Divider"
            />
          </div>
        ))}
    </div>
  )
}
